import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ArtisanSection.css';
import '../common-styles.css';

// Import artisan images
import artisan1 from '../../assets/images/artisan/1.png';
import artisan2 from '../../assets/images/artisan/2.png';
import artisan3 from '../../assets/images/artisan/3.png';
import artisan4 from '../../assets/images/artisan/4.png';
import artisan5 from '../../assets/images/artisan/5.png';

const ArtisanSection: React.FC = () => {
  return (
    <section className="section artisan-section">
      <Container>
        {/* Header */}
        <Row className="artisan-header mb-5">
          <Col>
            <div className="text-center">
              <div className="artisan-badge">ARTISANS</div>
              <h2 className="section-title">
                <span className="section-title-highlight">Artisans</span> of Precision
              </h2>
              <p className="artisan-description">
                At SunDiam, every diamond is a fusion of human mastery and cutting-edge innovation. Inside our eco-friendly, state-of-the-art facility in Surat, over 500 skilled artisans and engineers operate world-class systems — including Sarin Galaxy 50 planning and our proprietary SGS (SunDiam Grading System) diamond grading platform. With real-time global tracking, automated precision, and an unwavering commitment to detail, we craft each stone to the highest standards of beauty, ethics, and brilliance.
              </p>
            </div>
          </Col>
        </Row>

        {/* Collage */}
        <Row className="artisan-collage-row mb-5">
          <Col>
            <div className="artisan-collage">
              {/* Left Section - 2x2 Grid */}
              <div className="collage-left-section">
                {/* Top Row */}
                <div className="collage-row collage-row-top">
                  <div className="collage-item collage-large-topleft">
                    <img src={artisan1} alt="Artisan Workshop" className="collage-img" />
                  </div>
                  <div className="collage-item collage-medium-topright">
                    <img src={artisan2} alt="Diamond Inspection" className="collage-img" />
                  </div>
                </div>
                
                {/* Bottom Row */}
                <div className="collage-row collage-row-bottom">
                  <div className="collage-item collage-small-bottomleft">
                    <img src={artisan3} alt="Precision Tools" className="collage-img" />
                  </div>
                  <div className="collage-item collage-large-bottomright">
                    <img src={artisan4} alt="Diamond Collection" className="collage-img" />
                  </div>
                </div>
              </div>
              
              {/* Right Section - Tall Image */}
              <div className="collage-right-section">
                <div className="collage-item collage-tall-right">
                  <img src={artisan5} alt="Quality Control" className="collage-img" />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Button */}
        <Row>
          <Col>
            <div className="text-center">
              <Link to="/artisans">
                <Button className="section-btn">
                  <span className="btn-content">Read More <i className="fas fa-arrow-right btn-arrow-diagonal" /></span>
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ArtisanSection;
